// @ts-strict-ignore
import styled from "styled-components";
import { Paragraph1 } from "components/parts/Typography/cryptopedia";

export const Title = styled(Paragraph1)``;

export const ContentItem = styled(Paragraph1)`
  margin: 18px 24px 0 0;
`;

export const ContentList = styled.div`
  width: calc(50% - 385px);
  left: ${(props) => (props.visible ? "61px" : "-500px")};
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  position: sticky;
  top: 28px;
  height: ${(props) => (props.visible ? "unset" : "0")};
  opacity: ${(props) => (props.visible ? "1" : "0")};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  transition: all 0.1s ease;
  ${({ theme: { media } }) => media.desktop`
    display: block;
`}
  ul {
    margin: 0;
    padding-left: 0px;
    list-style: none;
  }
  a {
    text-decoration: none;
  }
  @media (max-width: 1143px) {
    display: none;
  }
`;
